import { render } from "./Taiwan.vue?vue&type=template&id=684c2ec0&scoped=true"
import script from "./Taiwan.vue?vue&type=script&lang=js"
export * from "./Taiwan.vue?vue&type=script&lang=js"

import "./Taiwan.vue?vue&type=style&index=0&id=684c2ec0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-684c2ec0"

export default script